const FirestoreCollection = require('../enums/firestore-collection');
const QuotationStatus = require('../enums/quotation-status');

/**
* Quotation
*/

class Quotation {

    constructor(document) {
        // TODO: checker comment ne pas avoir deux constructeur celui depuis doc Firebase et celui en init new Quotation
        const data = document.data()

        this.uid = document.id
        this.createdAt = data.createdAt ? data.createdAt : new Date()
        this.firstName = data.firstName
        this.lastName = data.lastName
        this.gender = data.gender
        this.phoneNumber = data.phoneNumber
        this.email = data.email
        this.address = data.address
        this.zipCode = data.zipCode
        this.city = data.city
        this.country = data.country
        this.deliveries = data.deliveries
        this.communicationType = data.communicationType
        this.amount = data.amount
        this.ownerUID = data.ownerUID
        this.status = data.status ? data.status : QuotationStatus.TODO
        this.quotationID = data.quotationID ? data.quotationID : makeQuotationID(6)
        }

    get data() {
        return {
            uid: this.uid,
            createdAt: this.createdAt,
            firstName: this.firstName,
            lastName: this.lastName,
            gender: this.gender,
            phoneNumber: this.phoneNumber,
            email: this.email,
            address: this.address,
            zipCode: this.zipCode,
            city: this.city,
            country: this.country,
            deliveries: this.deliveries,
            communicationType: this.communicationType,
            amount: this.amount,
            ownerUID: this.ownerUID,
            status: this.status,
            quotationID: this.quotationID
        }
    }

    ID() {
        return this.quotationID
    }

    firebaseStoragePath() {
        return "quotations/Devis-" + this.ID() + ".pdf"
    }

}

function makeQuotationID(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

export default Quotation;